<mat-icon *ngIf="comments" class="flipped small-icon" appTooltip="{{ comments }}">
    chat_bubble_outline
</mat-icon>